import { useDispatch, useSelector } from 'react-redux';
import { useCallback, useEffect, useState } from 'react';

import { Board } from 'types';
import { State } from 'redux/initialState';
import { getBoards } from 'modules/boards/redux/boardActions';

export const useBoardsList = (societyId: string | undefined) => {
  const dispatch = useDispatch();

  const boards: Board[] = useSelector((state: State) =>
    state.boards.sort(
      (a, b) => new Date(b.date).getTime() - new Date(a.date).getTime()
    )
  );

  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [isError, setIsError] = useState<boolean>(false);

  const fetchBoardsList = useCallback(async () => {
    if (!societyId) {
      return;
    }

    try {
      setIsLoading(true);
      setIsError(false);
      await dispatch(getBoards(societyId));
    } catch {
      setIsError(true);
    } finally {
      setIsLoading(false);
    }
  }, [societyId, dispatch]);

  useEffect(() => {
    fetchBoardsList();
  }, [fetchBoardsList]);

  return {
    data: boards,
    isLoading,
    isError,
  };
};
